<template>
  <div>
    <div class="d-flex flex-column">
      <b-button
        @click="setForm('flowDetail', true)"
        class="mb-5"
        :variant="forms.flowDetail ? 'warning' : 'outline-warning' "
      >
        Detalle de flujo
      </b-button>
      <b-button
        @click="setForm('observers', true)"
        class="mb-5"
        :variant="forms.observers ? 'info' : 'outline-info' "
      >
        Observadores
      </b-button>
      <b-button
        @click="setForm('consequences', true)"
        class="mb-5"
        :variant="forms.consequences ? 'info' : 'outline-info' "
      >
        Consecuencias
      </b-button>
      <b-button
        @click="setForm('steps', true)"
        class="mb-5"
        :variant="forms.steps ? 'warning' : 'outline-warning' "
      >
        Pasos
      </b-button>
      <b-button
        :disabled="loadingBtn"
        @click="saveData"
        variant="success"
        class="save-button margin"
        data-cy="approvals-action-save"
      >
        {{ getBtnText }}
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TemplatePartsButtons',
  props: ['data', 'forms', 'setForm', 'saveData', 'getBtnText', 'loadingBtn']
};
</script>

<style scoped>
.margin {
  margin-top: 60px;
}
.save-button {
  font-size: 20px;
}
</style>
